export default template;
function pug_attr(t,e,n,r){if(!1===e||null==e||!e&&("class"===t||"style"===t))return"";if(!0===e)return" "+(r?t:t+'="'+t+'"');var f=typeof e;return"object"!==f&&"function"!==f||"function"!=typeof e.toJSON||(e=e.toJSON()),"string"==typeof e||(e=JSON.stringify(e),n||-1===e.indexOf('"'))?(n&&(e=pug_escape(e))," "+t+'="'+e+'"'):" "+t+"='"+e.replace(/'/g,"&#39;")+"'"}
function pug_classes(s,r){return Array.isArray(s)?pug_classes_array(s,r):s&&"object"==typeof s?pug_classes_object(s):s||""}
function pug_classes_array(r,a){for(var s,e="",u="",c=Array.isArray(a),g=0;g<r.length;g++)(s=pug_classes(r[g]))&&(c&&a[g]&&(s=pug_escape(s)),e=e+u+s,u=" ");return e}
function pug_classes_object(r){var a="",n="";for(var o in r)o&&r[o]&&pug_has_own_property.call(r,o)&&(a=a+n+o,n=" ");return a}
function pug_escape(e){var a=""+e,t=pug_match_html.exec(a);if(!t)return e;var r,c,n,s="";for(r=t.index,c=0;r<a.length;r++){switch(a.charCodeAt(r)){case 34:n="&quot;";break;case 38:n="&amp;";break;case 60:n="&lt;";break;case 62:n="&gt;";break;default:continue}c!==r&&(s+=a.substring(c,r)),c=r+1,s+=n}return c!==r?s+a.substring(c,r):s}
var pug_has_own_property=Object.prototype.hasOwnProperty;
var pug_match_html=/["&<>]/;function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (calcStateClass, delivered, destination, emptyMessage, getDirectionsUrl, isSelected, navigator, orders, origin, prettyOption, renderCreatedDate, renderDeliveryNote, selected, suppressActions) {
      




































pug_mixins["render_address"] = pug_interp = function(address, order, suppressName, directionsUrl){
var block = (this && this.block), attributes = (this && this.attributes) || {};
pug_html = pug_html + "\u003Cdiv class=\"address\"\u003E";
if (directionsUrl) {
pug_html = pug_html + "\u003Ca" + (" class=\"directions\""+" target=\"_blank\""+pug_attr("href", directionsUrl, true, true)) + "\u003E\u003Cimg src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E";
}
if (! suppressName) {
pug_html = pug_html + "\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = address.fullName && address.fullName.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.fullName && address.fullName.lastName) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (address.company) {
pug_html = pug_html + "\u003Cdiv class=\"company\"\u003E" + (pug_escape(null == (pug_interp = address.company) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E";
if (address.street) {
pug_html = pug_html + ((pug_escape(null == (pug_interp = address.street.number) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.street.name) ? "" : pug_interp)));
}
else {
pug_html = pug_html + (pug_escape(null == (pug_interp = address.addressLine1) ? "" : pug_interp));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (address.addressLine2) {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E" + (pug_escape(null == (pug_interp = address.addressLine2) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (order && order.customField && order.customField.title == "Apartment Number, suite, etc") {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E" + (pug_escape(null == (pug_interp = order.customField.value) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cdiv class=\"city\"\u003E" + (pug_escape(null == (pug_interp = address.city) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = address.zipCode) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
if (! suppressName) {
pug_html = pug_html + "\u003Cdiv class=\"phone\"\u003E" + (pug_escape(null == (pug_interp = address.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
if (address.business) {
pug_html = pug_html + "\u003Cdiv class=\"line\"\u003E\u003Cstrong\u003E(Business)\u003C\u002Fstrong\u003E\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
pug_html = pug_html + "\u003Cdiv class=\"function-body\"\u003E";
if (orders) {
if (orders.length > 0) {
pug_html = pug_html + "\u003Cdiv class=\"controls noprint\"\u003E\u003Cbutton class=\"map clickable\"\u003EShow map";
if (selected && selected.length > 0 && selected.length != orders.length) {
pug_html = pug_html + ("\nof " + (pug_escape(null == (pug_interp = selected.length) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = selected.length == 1 ? "order" : "orders") ? "" : pug_interp)));
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
if (destination) {
pug_html = pug_html + "\u003Cdiv class=\"addresses\"\u003E\u003Cdiv\u003E\u003Clabel\u003EStart\n";
if (navigator.geolocation) {
pug_html = pug_html + "\u003Ca class=\"use-current-location clickable\"\u003E(set to current location)\u003C\u002Fa\u003E";
}
pug_html = pug_html + "\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"address form-control\""+" name=\"origin\""+pug_attr("value", origin.address, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv\u003E\u003Clabel\u003EEnd\u003C\u002Flabel\u003E\u003Cinput" + (" class=\"address form-control\""+" name=\"destination\""+pug_attr("value", destination.address, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbutton class=\"sort clickable\"\u003ESort orders into efficient delivery route";
if (selected && selected.length > 0 && selected.length != orders.length) {
pug_html = pug_html + "\nputting " + (pug_escape(null == (pug_interp = selected.length) ? "" : pug_interp)) + " selected " + (pug_escape(null == (pug_interp = selected.length == 1 ? "order" : "orders") ? "" : pug_interp)) + " first";
}
pug_html = pug_html + "\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"orders\"\u003E\u003Cdiv class=\"order\"\u003E\u003Cdiv class=\"control no-border\"\u003E\u003Cinput" + (" class=\"select-all\""+" type=\"checkbox\""+pug_attr("checked", selected && selected.length == orders.length, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"lineItems no-border\"\u003E";
if (selected && selected.length == orders.length) {
pug_html = pug_html + ("Unselect " + (pug_escape(null == (pug_interp = selected.length) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = selected.length == 1 ? "order" : "orders") ? "" : pug_interp)));
}
else {
pug_html = pug_html + ("Select " + (pug_escape(null == (pug_interp = orders.length) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = orders.length == 1 ? "order" : "orders") ? "" : pug_interp)));
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
// iterate orders
;(function(){
  var $$obj = orders;
  if ('number' == typeof $$obj.length) {
      for (var pug_index3 = 0, $$l = $$obj.length; pug_index3 < $$l; pug_index3++) {
        var order = $$obj[pug_index3];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
var stateClass = calcStateClass(order)
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["order",{"no-delivery-date": !order.deliveryDate},stateClass], [false,true,true]), false, true)+pug_attr("data-orderid", order.id, true, true)) + "\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput" + (" class=\"select\""+" type=\"checkbox\""+pug_attr("checked", isSelected(order), true, true)+pug_attr("data-id", order.id, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dateCreated orderClickable clickable\"\u003E" + (pug_escape(null == (pug_interp = renderCreatedDate(order.dateCreated)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"lineItems orderClickable\"\u003E";
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index4 = 0, $$l = $$obj.length; pug_index4 < $$l; pug_index4++) {
        var lineItem = $$obj[pug_index4];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E\u003Cdiv class=\"clickable\"\u003E#" + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\n" + (pug_escape(null == (pug_interp = lineItem.name) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (prettyOption) {
pug_html = pug_html + "\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index5 = 0, $$l = $$obj.length; pug_index5 < $$l; pug_index5++) {
        var option = $$obj[pug_index5];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index5 in $$obj) {
      $$l++;
      var option = $$obj[pug_index5];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index4 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index4];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E\u003Cdiv class=\"clickable\"\u003E#" + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\n" + (pug_escape(null == (pug_interp = lineItem.name) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (prettyOption) {
pug_html = pug_html + "\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index6 = 0, $$l = $$obj.length; pug_index6 < $$l; pug_index6++) {
        var option = $$obj[pug_index6];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index6 in $$obj) {
      $$l++;
      var option = $$obj[pug_index6];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo orderClickable clickable\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliveryNote\"\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliveryDate\"\u003E";
if (order.deliveryDate) {
pug_html = pug_html + "\u003Cb\u003E " + (pug_escape(null == (pug_interp = renderDeliveryNote(order)) ? "" : pug_interp)) + "\u003C\u002Fb\u003E";
}
pug_html = pug_html + "\u003Cdiv\u003E\u003Cb\u003E" + (pug_escape(null == (pug_interp = order.currentStatus) ? "" : pug_interp)) + "\u003C\u002Fb\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"noprint\"\u003E\u003Ca" + (" class=\"clickable directions\""+" target=\"_blank\""+pug_attr("href", getDirectionsUrl(order), true, true)) + "\u003E\u003Cimg class=\"navigation\" src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index3 in $$obj) {
      $$l++;
      var order = $$obj[pug_index3];
var shipmentDetailsAddress = order.shippingInfo && order.shippingInfo.shipmentDetails && order.shippingInfo.shipmentDetails.address;
var stateClass = calcStateClass(order)
pug_html = pug_html + "\u003Cdiv" + (pug_attr("class", pug_classes(["order",{"no-delivery-date": !order.deliveryDate},stateClass], [false,true,true]), false, true)+pug_attr("data-orderid", order.id, true, true)) + "\u003E\u003Cdiv class=\"control\"\u003E\u003Cinput" + (" class=\"select\""+" type=\"checkbox\""+pug_attr("checked", isSelected(order), true, true)+pug_attr("data-id", order.id, true, true)) + "\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"dateCreated orderClickable clickable\"\u003E" + (pug_escape(null == (pug_interp = renderCreatedDate(order.dateCreated)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"lineItems orderClickable\"\u003E";
// iterate order.lineItems
;(function(){
  var $$obj = order.lineItems;
  if ('number' == typeof $$obj.length) {
      for (var pug_index7 = 0, $$l = $$obj.length; pug_index7 < $$l; pug_index7++) {
        var lineItem = $$obj[pug_index7];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E\u003Cdiv class=\"clickable\"\u003E#" + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\n" + (pug_escape(null == (pug_interp = lineItem.name) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (prettyOption) {
pug_html = pug_html + "\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index8 = 0, $$l = $$obj.length; pug_index8 < $$l; pug_index8++) {
        var option = $$obj[pug_index8];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index8 in $$obj) {
      $$l++;
      var option = $$obj[pug_index8];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index7 in $$obj) {
      $$l++;
      var lineItem = $$obj[pug_index7];
pug_html = pug_html + ("\u003Cdiv class=\"lineItem\"\u003E\u003Cdiv class=\"name\"\u003E\u003Cdiv class=\"clickable\"\u003E#" + (pug_escape(null == (pug_interp = order.number) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\n" + (pug_escape(null == (pug_interp = lineItem.name) ? "" : pug_interp)));
if (lineItem.quantity > 1) {
pug_html = pug_html + "\n\u003Cstrong\u003EQuantity: " + (pug_escape(null == (pug_interp = lineItem.quantity) ? "" : pug_interp)) + "\u003C\u002Fstrong\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
if (prettyOption) {
pug_html = pug_html + "\u003Cdiv class=\"options\"\u003E";
// iterate (lineItem.options || [])
;(function(){
  var $$obj = (lineItem.options || []);
  if ('number' == typeof $$obj.length) {
      for (var pug_index9 = 0, $$l = $$obj.length; pug_index9 < $$l; pug_index9++) {
        var option = $$obj[pug_index9];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var pug_index9 in $$obj) {
      $$l++;
      var option = $$obj[pug_index9];
if (option.selection != "No" && option.option.indexOf("Add ") == 0) {
pug_html = pug_html + "\u003Cdiv class=\"option\"\u003E" + (pug_escape(null == (pug_interp = prettyOption(option)) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"buyerInfo orderClickable clickable\"\u003E\u003Cdiv class=\"name\"\u003E" + (pug_escape(null == (pug_interp = order.buyerInfo.firstName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.lastName) ? "" : pug_interp)) + " " + (pug_escape(null == (pug_interp = order.buyerInfo.phone) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliveryNote\"\u003E";
if (shipmentDetailsAddress) {
pug_html = pug_html + "\u003Cdiv class=\"delivery-address\"\u003E";
pug_mixins["render_address"](shipmentDetailsAddress, order);
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E\u003Cdiv class=\"deliveryDate\"\u003E";
if (order.deliveryDate) {
pug_html = pug_html + "\u003Cb\u003E " + (pug_escape(null == (pug_interp = renderDeliveryNote(order)) ? "" : pug_interp)) + "\u003C\u002Fb\u003E";
}
pug_html = pug_html + "\u003Cdiv\u003E\u003Cb\u003E" + (pug_escape(null == (pug_interp = order.currentStatus) ? "" : pug_interp)) + "\u003C\u002Fb\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"noprint\"\u003E\u003Ca" + (" class=\"clickable directions\""+" target=\"_blank\""+pug_attr("href", getDirectionsUrl(order), true, true)) + "\u003E\u003Cimg class=\"navigation\" src=\"images\u002Fnavigation.png\"\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
if (! suppressActions) {
pug_html = pug_html + "\u003Cdiv class=\"actions\"\u003E";
if (selected && selected.length > 0) {
pug_html = pug_html + "\u003Cbutton class=\"remove-selected noprint clickable\"\u003ERemove\u003C\u002Fbutton\u003E";
}
else {
pug_html = pug_html + "\u003Cbutton class=\"remove-all noprint clickable\"\u003ERemove all\u003C\u002Fbutton\u003E";
}
if (delivered && delivered.length > 0) {
pug_html = pug_html + "\u003Cbutton class=\"remove-delivered noprint clickable\"\u003ERemove delivered\u003C\u002Fbutton\u003E";
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
}
}
else {
pug_html = pug_html + "\u003Cp\u003E" + (pug_escape(null == (pug_interp = emptyMessage) ? "" : pug_interp)) + "\u003C\u002Fp\u003E";
}
}
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
    }.call(this, "calcStateClass" in locals_for_with ?
        locals_for_with.calcStateClass :
        typeof calcStateClass !== 'undefined' ? calcStateClass : undefined, "delivered" in locals_for_with ?
        locals_for_with.delivered :
        typeof delivered !== 'undefined' ? delivered : undefined, "destination" in locals_for_with ?
        locals_for_with.destination :
        typeof destination !== 'undefined' ? destination : undefined, "emptyMessage" in locals_for_with ?
        locals_for_with.emptyMessage :
        typeof emptyMessage !== 'undefined' ? emptyMessage : undefined, "getDirectionsUrl" in locals_for_with ?
        locals_for_with.getDirectionsUrl :
        typeof getDirectionsUrl !== 'undefined' ? getDirectionsUrl : undefined, "isSelected" in locals_for_with ?
        locals_for_with.isSelected :
        typeof isSelected !== 'undefined' ? isSelected : undefined, "navigator" in locals_for_with ?
        locals_for_with.navigator :
        typeof navigator !== 'undefined' ? navigator : undefined, "orders" in locals_for_with ?
        locals_for_with.orders :
        typeof orders !== 'undefined' ? orders : undefined, "origin" in locals_for_with ?
        locals_for_with.origin :
        typeof origin !== 'undefined' ? origin : undefined, "prettyOption" in locals_for_with ?
        locals_for_with.prettyOption :
        typeof prettyOption !== 'undefined' ? prettyOption : undefined, "renderCreatedDate" in locals_for_with ?
        locals_for_with.renderCreatedDate :
        typeof renderCreatedDate !== 'undefined' ? renderCreatedDate : undefined, "renderDeliveryNote" in locals_for_with ?
        locals_for_with.renderDeliveryNote :
        typeof renderDeliveryNote !== 'undefined' ? renderDeliveryNote : undefined, "selected" in locals_for_with ?
        locals_for_with.selected :
        typeof selected !== 'undefined' ? selected : undefined, "suppressActions" in locals_for_with ?
        locals_for_with.suppressActions :
        typeof suppressActions !== 'undefined' ? suppressActions : undefined));
    ;;return pug_html;}